import { AutogenLayoutCreditAndCollections } from "./autogen/AutogenLayoutCreditAndCollections";

export class CreditAndCollections extends AutogenLayoutCreditAndCollections {

}
